import { render } from "./MainLayout.vue?vue&type=template&id=2c176ce2&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=2c176ce2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Лейла\\Desktop\\azbcrm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c176ce2"]])

export default __exports__